import { render, staticRenderFns } from "./UserCompanies.vue?vue&type=template&id=5b362b8e"
import script from "./UserCompanies.vue?vue&type=script&lang=js"
export * from "./UserCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports